var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRecordsFound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258.965,
    height: 258.965,
    viewBox: "0 0 258.965 258.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path699",
    d: "M0-682.665H258.965V-423.7H0Z",
    transform: "translate(0 682.665)",
    fill: "#06f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40269",
    "data-name": "Group 40269",
    transform: "translate(-1288.272 -564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g693",
    transform: "translate(1288.272 564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g695",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g697",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g703",
    transform: "translate(221.705 87.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path705",
    d: "M-54.754-244.472a3.793,3.793,0,0,1-3.793-3.793V-390.421a2,2,0,0,0-2-2H-84.426a3.793,3.793,0,0,1-3.793-3.793A3.793,3.793,0,0,1-84.426-400h23.881a9.6,9.6,0,0,1,9.584,9.584v142.155A3.793,3.793,0,0,1-54.754-244.472Z",
    transform: "translate(88.22 400.004)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g707",
    transform: "translate(54.432 124.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path709",
    d: "M-6.207,32.287A3.793,3.793,0,0,1-10,28.493v-34.7A3.793,3.793,0,0,1-6.207-10,3.793,3.793,0,0,1-2.413-6.207v34.7A3.793,3.793,0,0,1-6.207,32.287Z",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g711",
    transform: "translate(115.189 68.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path713",
    d: "M-57.286-24.589A3.782,3.782,0,0,1-59.968-25.7L-71.826-37.558a1.984,1.984,0,0,0-1.413-.585H-88.505A3.793,3.793,0,0,1-92.3-41.936a3.793,3.793,0,0,1,3.793-3.793h15.267a9.522,9.522,0,0,1,6.777,2.807L-54.6-31.064a3.793,3.793,0,0,1,0,5.365A3.782,3.782,0,0,1-57.286-24.589Z",
    transform: "translate(92.298 45.729)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g715",
    transform: "translate(173.847 87.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path717",
    d: "M-53.868-2.413H-83a3.793,3.793,0,0,1-3.793-3.793A3.793,3.793,0,0,1-83-10h29.13a3.793,3.793,0,0,1,3.793,3.793A3.793,3.793,0,0,1-53.868-2.413Z",
    transform: "translate(86.792 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g719",
    transform: "translate(-0.002 160.972)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path721",
    d: "M-84.057,72.347H-278.25a9.548,9.548,0,0,1-7.435-3.536l-51.384-63.18a9.505,9.505,0,0,1-1.219-10.164A9.506,9.506,0,0,1-329.633-10h119.087a3.793,3.793,0,0,1,3.793,3.793,3.793,3.793,0,0,1-3.793,3.793H-329.633a1.943,1.943,0,0,0-1.8,1.139,1.942,1.942,0,0,0,.254,2.118L-279.8,64.023a1.991,1.991,0,0,0,1.55.737H-92.032L-146.064-1.676a1.989,1.989,0,0,0-1.549-.737h-44.2a3.793,3.793,0,0,1-3.793-3.793A3.793,3.793,0,0,1-191.818-10h44.2a9.546,9.546,0,0,1,7.435,3.537L-81.114,66.16a3.793,3.793,0,0,1,.483,4.023A3.793,3.793,0,0,1-84.057,72.347Z",
    transform: "translate(339.231 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g723",
    transform: "translate(138.664 195.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path725",
    d: "M-118.668-40.471h-51.094a8.9,8.9,0,0,1-7.043-3.49L-189.9-61.167a6.285,6.285,0,0,1-.634-6.637,6.285,6.285,0,0,1,5.665-3.515h51.094a8.9,8.9,0,0,1,7.043,3.491l13.094,17.205A6.285,6.285,0,0,1-113-43.985,6.285,6.285,0,0,1-118.668-40.471Zm-63.649-23.261,11.549,15.175a1.273,1.273,0,0,0,1.006.5h48.543l-11.549-15.175a1.271,1.271,0,0,0-1.006-.5Z",
    transform: "translate(191.197 71.318)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g727",
    transform: "translate(102.48 218.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path729",
    d: "M-44.18-2.413H-67.389a3.793,3.793,0,0,1-3.793-3.793A3.793,3.793,0,0,1-67.389-10H-44.18a3.793,3.793,0,0,1,3.793,3.793A3.793,3.793,0,0,1-44.18-2.413Z",
    transform: "translate(71.182 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g731",
    transform: "translate(107.368 206.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path733",
    d: "M-22.325-2.413h-9.851a3.793,3.793,0,0,1-3.793-3.793A3.793,3.793,0,0,1-32.176-10h9.851a3.793,3.793,0,0,1,3.793,3.793A3.793,3.793,0,0,1-22.325-2.413Z",
    transform: "translate(35.969 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g735",
    transform: "translate(5.498 15.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path737",
    d: "M-134.43,79.157h-44.58a58.206,58.206,0,0,1-58.14-58.14,57.752,57.752,0,0,1,17.039-41.1,57.753,57.753,0,0,1,41.1-17.04,57.722,57.722,0,0,1,34.044,11.009,3.793,3.793,0,0,1,.85,5.3,3.793,3.793,0,0,1-5.3.85,50.181,50.181,0,0,0-29.6-9.569A50.216,50.216,0,0,0-214.746-14.72a50.215,50.215,0,0,0-14.817,35.737A50.611,50.611,0,0,0-179.01,71.57h44.58l.178-.431-9.012-9.012a3.794,3.794,0,0,1-1.111-2.682,3.793,3.793,0,0,1,1.111-2.682,50.221,50.221,0,0,0,14.807-35.747,50.273,50.273,0,0,0-8.8-28.5,3.793,3.793,0,0,1,.99-5.273,3.793,3.793,0,0,1,5.273.99,57.829,57.829,0,0,1,10.121,32.782A57.709,57.709,0,0,1-135.3,59.36l6.415,6.415a7.816,7.816,0,0,1,1.7,8.543A7.816,7.816,0,0,1-134.43,79.157Z",
    transform: "translate(237.15 37.124)",
    fill: "#06f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g739",
    transform: "translate(36.789 46.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path741",
    d: "M-56.738-17.083a11.305,11.305,0,0,1-8.047-3.333l-7.427-7.427-7.427,7.427a11.306,11.306,0,0,1-8.047,3.333,11.305,11.305,0,0,1-8.047-3.333,11.393,11.393,0,0,1,0-16.094l7.427-7.427-7.427-7.427a11.393,11.393,0,0,1,0-16.094,11.3,11.3,0,0,1,8.047-3.333,11.306,11.306,0,0,1,8.047,3.333l7.427,7.427,7.427-7.427a11.3,11.3,0,0,1,8.047-3.333,11.306,11.306,0,0,1,8.047,3.333,11.393,11.393,0,0,1,0,16.094l-7.427,7.427,7.427,7.427a11.393,11.393,0,0,1,0,16.094A11.308,11.308,0,0,1-56.738-17.083ZM-72.212-37a3.793,3.793,0,0,1,2.682,1.111l10.11,10.11a3.768,3.768,0,0,0,2.682,1.111,3.77,3.77,0,0,0,2.683-1.111,3.8,3.8,0,0,0,0-5.364l-10.11-10.11a3.793,3.793,0,0,1-1.111-2.682,3.793,3.793,0,0,1,1.111-2.682l10.11-10.11a3.8,3.8,0,0,0,0-5.365,3.769,3.769,0,0,0-2.682-1.111,3.767,3.767,0,0,0-2.682,1.111l-10.11,10.11a3.771,3.771,0,0,1-2.682,1.111,3.793,3.793,0,0,1-2.682-1.111L-85-62.095a3.769,3.769,0,0,0-2.682-1.111,3.768,3.768,0,0,0-2.682,1.111,3.8,3.8,0,0,0,0,5.365l10.109,10.11a3.793,3.793,0,0,1,0,5.365l-10.109,10.11a3.8,3.8,0,0,0,0,5.365,3.768,3.768,0,0,0,2.682,1.111A3.769,3.769,0,0,0-85-25.781l10.109-10.11A3.793,3.793,0,0,1-72.212-37Z",
    transform: "translate(99.061 70.792)",
    fill: "#06f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g743",
    transform: "translate(144.989 75.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path745",
    d: "M-66.522-47.217A17.932,17.932,0,0,1-48.61-29.306,17.932,17.932,0,0,1-66.522-11.394,17.932,17.932,0,0,1-84.433-29.306,17.932,17.932,0,0,1-66.522-47.217Zm0,28.236A10.336,10.336,0,0,0-56.2-29.306,10.336,10.336,0,0,0-66.522-39.63,10.336,10.336,0,0,0-76.846-29.306,10.336,10.336,0,0,0-66.522-18.981Z",
    transform: "translate(84.433 47.217)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g747",
    transform: "translate(197.409 50.739)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path749",
    d: "M-53.8-39.369A14.951,14.951,0,0,1-38.87-24.435,14.951,14.951,0,0,1-53.8-9.5,14.951,14.951,0,0,1-68.738-24.435,14.951,14.951,0,0,1-53.8-39.369Zm0,22.282a7.356,7.356,0,0,0,7.348-7.348A7.356,7.356,0,0,0-53.8-31.782a7.356,7.356,0,0,0-7.348,7.348A7.356,7.356,0,0,0-53.8-17.087Z",
    transform: "translate(68.738 39.369)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g751",
    transform: "translate(172.994 36.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path753",
    d: "M-31.169,7.056a3.782,3.782,0,0,1-2.682-1.111,3.793,3.793,0,0,1,0-5.365l9.469-9.469a3.793,3.793,0,0,1,5.365,0,3.793,3.793,0,0,1,0,5.365l-9.469,9.469A3.782,3.782,0,0,1-31.169,7.056Z",
    transform: "translate(34.963 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g755",
    transform: "translate(172.994 36.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path757",
    d: "M-21.7-17.906a3.782,3.782,0,0,1-2.682-1.111l-9.469-9.469a3.793,3.793,0,0,1,0-5.365,3.793,3.793,0,0,1,5.365,0l9.469,9.469a3.793,3.793,0,0,1,0,5.365A3.782,3.782,0,0,1-21.7-17.906Z",
    transform: "translate(34.963 34.963)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g759",
    transform: "translate(13.209 130.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path761",
    d: "M-39.188,10.1A3.782,3.782,0,0,1-41.87,8.987a3.793,3.793,0,0,1,0-5.365L-29.359-8.889a3.793,3.793,0,0,1,5.365,0,3.793,3.793,0,0,1,0,5.365L-36.505,8.987A3.782,3.782,0,0,1-39.188,10.1Z",
    transform: "translate(42.981 10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g763",
    transform: "translate(13.209 130.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path765",
    d: "M-26.677-22.883a3.782,3.782,0,0,1-2.682-1.111L-41.87-36.505a3.793,3.793,0,0,1,0-5.365,3.793,3.793,0,0,1,5.365,0l12.511,12.511a3.793,3.793,0,0,1,0,5.365A3.782,3.782,0,0,1-26.677-22.883Z",
    transform: "translate(42.981 42.981)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g755-2",
    "data-name": "g755",
    transform: "translate(1461.267 600.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path757-2",
    "data-name": "path757",
    d: "M-21.7-17.906a3.782,3.782,0,0,1-2.682-1.111l-9.469-9.469a3.793,3.793,0,0,1,0-5.365,3.793,3.793,0,0,1,5.365,0l9.469,9.469a3.793,3.793,0,0,1,0,5.365A3.782,3.782,0,0,1-21.7-17.906Z",
    transform: "translate(34.963 34.963)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordsFound);
export default __webpack_public_path__ + "static/media/no-records-found.70323a4a72792c3fa48b3cf061699b8d.svg";
export { ForwardRef as ReactComponent };